import { Component, OnInit, Input } from '@angular/core';
import { WorkspaceService } from '../services/workspace.service';
import { ReportGroup, ReportObject, PageContent, ConversationResult } from '../objects/WorkObject';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-khamis-dialog',
  templateUrl: './khamis-dialog.component.html',
  styleUrls: ['./khamis-dialog.component.css']
})
export class KhamisDialogComponent implements OnInit {
  private componentId:string;
  //private reportGroupList:ReportGroup[] = [];
  private conversationResultList:ConversationResult[] = [];
  gridRow: 30;
  messageId: string;

  @Input() pageContent: PageContent;
  @Input() reportGroupWidth: number;
  @Input() set searchResultId(searchResultId:string){
    if(searchResultId){
        this.componentId = searchResultId;
    }
  }

  @Input() set searchResultChanged(searchResultId:string){
      var id = "00000000-0000-0000-0000-000000000000";
      if (this.componentId) {
          id = this.componentId;
      }

      this.workspaceService.getSearchResult(id).subscribe(result=>{
        if (result){
          this.conversationResultList = JSON.parse(result);

          this.conversationResultList.forEach(function (conv) {
              conv.EPICGroups.forEach(function (group) {
                  group.EPICs.forEach(function (epic) {
                      if (epic.TemplateType == 'WebContent') {
                          if (epic.Width > 32) {
                              group.Width = this.reportGroupWidth;
                              group.FullWidth = "repeat (36, 1fr)";
                              group.FullHeight = "repeat(" + epic.Height + ", 45px)";
                              epic.Width = this.reportGroupWidth;
                          }
                      }
                  });
              });
          });

          this.reverseSortConversation(this.conversationResultList);
          this.conversationResultList.forEach(element => {
            element.ConversationMessage.MessageDateTimeConverted = new DatePipe("en-US").transform(element.ConversationMessage.MessageDateTime, "dd/MM/yyyy hh:mm:ss a");
          });
          // this.conversationResultList.forEach(element => {
          //     element.EPICGroups.forEach(element => {
          //       this.setStartRow(element.EPICs);
          //     });
          // });
        }
      })
  }

  reverseSortConversation(conversationResultList:ConversationResult[]){
    this.conversationResultList = conversationResultList.sort((a:ConversationResult,b:ConversationResult) => {
      if(a.ConversationOrder < b.ConversationOrder){
        return 1;
      }else if(a.ConversationOrder > b.ConversationOrder){
        return -1;
      }else{
        return 0;
      }
    });
  }

  setStartRow(reportGroup:ReportObject[]){
    var startRow = 1;
    reportGroup.forEach(x => {
      x.StartRow = startRow;
      if (x.BreakAfter) startRow = startRow + x.Height;
    });
  }

  constructor(private workspaceService:WorkspaceService) {}

  ngOnInit() {
  }
  
  getRelatedEpics(conversationResult:ConversationResult, epicGroup:ReportGroup) {
    this.workspaceService.getRelatedEPICs(conversationResult.ConversationMessage.ConversationId, conversationResult.ConversationMessage.MessageId, epicGroup.GroupId, epicGroup.GroupOrder.toString()).subscribe(result=>{
      var converse:ConversationResult = JSON.parse(result);
      let itemIndex = this.conversationResultList.findIndex(item => item.ConversationMessage.ConversationId == converse.ConversationMessage.ConversationId);
      this.conversationResultList[itemIndex] = converse;
      this.conversationResultList[itemIndex].ConversationMessage.MessageDateTimeConverted = new DatePipe("en-US").transform(this.conversationResultList[itemIndex].ConversationMessage.MessageDateTime, "dd/MM/yyyy hh:mm:ss a");
      document.querySelectorAll('.body-wrapper').item(0).scrollTop = 130;
    });
  }

  toggle(id:string){
    if (this.messageId == id){
      this.messageId = '';
    }
    else{
      this.messageId = id;
    }
  }
}
